<template>
  <div v-if="bill.invoiceStatus === 'billed'">
    <button
        v-if="bill.coachingType === 'private_coaching'"
        class="btn btn-primary"
        :class="{ 'btn-padded': icon }"
        @click.prevent="cancellationBill(bill.id, 'private_coaching')">
      <i v-if="icon" class="fa-solid fa-ban me-1"></i>{{ $t('general.cancellation') }}
    </button>

    <button
        v-if="bill.coachingType === 'group_coaching'"
        class="btn btn-primary"
        :class="{ 'btn-padded': icon }"
        @click.prevent="cancellationBill(bill.id, 'group_coaching')">
      <i v-if="icon" class="fa-solid fa-ban me-1"></i>{{ $t('general.cancellation') }}
    </button>

    <button
        v-if="bill.coachingType === 'socio_therapy_coaching'"
        class="btn btn-primary"
        :class="{ 'btn-padded': icon }"
        @click.prevent="cancellationBill(bill.id, 'socio_therapy_coaching')">
      <i v-if="icon" class="fa-solid fa-ban me-1"></i>{{ $t('general.cancellation') }}
    </button>

    <button
        v-if="bill.coachingType === 'assisted_living_coaching'"
        class="btn btn-primary"
        :class="{ 'btn-padded': icon }"
        @click.prevent="cancellationBill(bill.id, 'assisted_living_coaching')">
      <i v-if="icon" class="fa-solid fa-ban me-1"></i>{{ $t('general.cancellation') }}
    </button>

    <button
        v-if="bill.coachingType === 'case_management_coaching'"
        class="btn btn-primary"
        :class="{ 'btn-padded': icon }"
        @click.prevent="cancellationBill(bill.id, 'case_management_coaching')">
      <i v-if="icon" class="fa-solid fa-ban me-1"></i>{{ $t('general.cancellation') }}
    </button>

    <button
        v-if="bill.coachingType === 'private_learning_coaching'"
        class="btn btn-primary"
        :class="{ 'btn-padded': icon }"
        @click.prevent="cancellationBill(bill.id, 'private_learning_coaching')">
      <i v-if="icon" class="fa-solid fa-ban me-1"></i>{{ $t('general.cancellation') }}
    </button>

    <button
        v-if="bill.coachingType === 'special_case'"
        class="btn btn-primary"
        :class="{ 'btn-padded': icon }"
        @click.prevent="cancellationBill(bill.id, 'special_case')">
      <i v-if="icon" class="fa-solid fa-ban me-1"></i>{{ $t('general.cancellation') }}
    </button>
  </div>
</template>

<script setup>
import { CloseToast } from '@/components/VueToast';
import { defineEmits, defineProps } from 'vue';

const emit  = defineEmits([ 'billCancellation' ]);
const props = defineProps({
  bill: {
    type: Object,
    required: true,
  },
  icon: {
    type: Boolean,
    default: false,
  },
});

const cancellationBill = (id, billType) => {
  CloseToast();
  emit('billCancellation', id, billType);
};

</script>

<style scoped>
.btn-padded {
  padding-top: 8px;
  padding-bottom: 8px;
}
</style>
